export default class RowNumber {
  constructor(filtered, total, serverLimit) {
    this.filtered = filtered;
    this.total = total;
    this.subscribers = [];
    this.serverLimit = serverLimit;
  }

  subscribe(subscriber) {
    this.subscribers.push(subscriber);
    return subscriber;
  }

  computeLabel(label) {
    const total = this.serverLimit && (this.total === this.serverLimit) ? `Last ${this.total}` : this.total;
    if (this.total === this.filtered) {
      return !this.total ? label : `${label} (${total})`;
    }
    return `${label} (${this.filtered}/${total})`;
  }

  subscribeSuffiexedLabel(label, onLabelChange) {
    return this.subscribe(() => {
      onLabelChange(this.computeLabel(label));
    });
  }

  unsubscribe(subscriber) {
    let index = this.subscribers.indexOf(subscriber);
    if ((index < 0) && subscriber && subscriber.subscriber) {
      index = this.subscribers.indexOf(subscriber.subscriber);
    }
    if (index >= 0) {
      this.subscribers.splice(index, subscriber);
      return true;
    }
    return false;
  }

  setFilteredRowCount(filtered) {
    if (this.filtered !== filtered) {
      this.filtered = filtered;
      this.subscribers.forEach((s) => {
        s([filtered, this.total]);
      });
    }
  }

  setTotalRowCount(total) {
    if (this.total !== total) {
      this.total = total;
      this.subscribers.forEach((s) => {
        s([this.filtered, this.total]);
      });
    }
  }

  setRowNumbers(filtered, total) {
    if ((this.filtered !== filtered) || (this.total !== total)) {
      this.filtered = filtered;
      this.total = total;
      this.subscribers.forEach((s) => {
        s([filtered, total]);
      });
    }
  }

  getRowNumbers() { return [this.filtered, this.total]; }
}
